const domainTypeRadioButtonLabels = {
    add: 'Domain type',
    changeType: 'Change domain type to',
    remove: '',
};

export default domainTypeRadioButtonLabels;
